import { isUuidV4String, newFloorPlanUuidV4 } from '../../../internal/floor-plan-uuid';
import { floorPlanFiniteNumber } from '../../../geometry/floor-plan-konva-sync';
import type { FloorPlanDrawItemLabels } from '../floor-plan-wire-types';
import type { UppKonvaShapeSource } from '../../../../model/upp-konva-source';
import type { UppFloorPlanElementOptions } from '../../floor-plan-element';
import type { UppKonvaShape } from '../floor-plan-wire-types';

export function elementOptsFromLabels(
  row: FloorPlanDrawItemLabels & { attention?: boolean },
  attentionAllowed: boolean,
): Partial<UppFloorPlanElementOptions> | undefined {
  const p: Partial<UppFloorPlanElementOptions> = {};
  if (row.label !== undefined && row.label !== '') {
    p.label = row.label;
  }
  if (row.sublabel !== undefined && row.sublabel !== '') {
    p.sublabel = row.sublabel;
  }
  if (Object.prototype.hasOwnProperty.call(row, 'custom')) {
    p.custom = row.custom as any;
  }
  if (attentionAllowed && row.attention === true) {
    p.attention = true;
  }
  return Object.keys(p).length > 0 ? p : undefined;
}

export function shapeDataRecord(row: UppKonvaShapeSource): Record<string, unknown> {
  const d = row.data;
  return typeof d === 'object' && d !== null && !Array.isArray(d) ? (d as Record<string, unknown>) : {};
}

export function shapeLabelsForBridge(row: UppKonvaShapeSource): Record<string, unknown> {
  const o: Record<string, unknown> = {};
  if (row.label !== undefined && row.label !== '') {
    o['label'] = row.label;
  }
  if (row.sublabel !== undefined && row.sublabel !== '') {
    o['sublabel'] = row.sublabel;
  }
  if (Object.prototype.hasOwnProperty.call(row, 'custom')) {
    o['custom'] = row.custom;
  }
  if (row.zIndex !== undefined) {
    o['zIndex'] = row.zIndex;
  }
  return o;
}

/** Normalizes wire-row cm geometry so Konva never receives `NaN` from stale DTO fields. */
export function normalizeWireShapeGeometry(row: UppKonvaShape): UppKonvaShape {
  const r = row as UppKonvaShape & {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    rotation?: number;
  };
  return {
    ...row,
    x: floorPlanFiniteNumber(r.x),
    y: floorPlanFiniteNumber(r.y),
    ...(Object.prototype.hasOwnProperty.call(r, 'width')
      ? { width: floorPlanFiniteNumber(r.width) }
      : {}),
    ...(Object.prototype.hasOwnProperty.call(r, 'height')
      ? { height: floorPlanFiniteNumber(r.height) }
      : {}),
    ...(Object.prototype.hasOwnProperty.call(r, 'rotation')
      ? { rotation: floorPlanFiniteNumber(r.rotation) }
      : {}),
  };
}

export function shapeRowIdentity(row: UppKonvaShapeSource): { uuid?: string; id: string } {
  const raw = (row.id ?? '').trim();
  if (raw === '') {
    const u = newFloorPlanUuidV4();
    return { uuid: u, id: u };
  }
  return isUuidV4String(raw) ? { uuid: raw, id: raw } : { id: raw };
}

export function sofaShapeFromDrawItemShape(shape: string | undefined): import('../../floor-plan-element').UppFloorPlanSofaShape {
  const u = (shape ?? 'LINEAR').toUpperCase();
  if (u === 'TOLEFT' || u === 'TORIGHT') {
    return u;
  }
  return 'LINEAR';
}
